const PURCHASED_CUSTOM_PRINT_STATUS = {
  CUSTOMER_INPUT: 'CUSTOMER_INPUT',
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  SHIPPED: 'SHIPPED',
  CANCELED: 'CANCELED',
  PENDING_REVIEW: 'PENDING_REVIEW',
};

const PCM_ORDER_STATUS = {
  MAILING: 'MAILING',
  DELIVERED: 'DELIVERED',
};

const SPECIALTY_PRINTS_PHOTOS_NO = [1, 2, 3, 4, 5];

const STUDENT_ID_CARD_TYPE = {
  STUDENT: 'STUDENT',
  STAFF: 'STAFF',
};

export {
  PURCHASED_CUSTOM_PRINT_STATUS,
  PCM_ORDER_STATUS,
  SPECIALTY_PRINTS_PHOTOS_NO,
  STUDENT_ID_CARD_TYPE,
};
